import { useMessages } from '@/i18n'
import { messages } from './messages'
import { Trash2, RefreshCw } from 'lucide-react'
import type { DesignElement, DesignImage } from '@/types/blocks'
import { useContentLang } from '@/features/editor/hooks/useContentLang'
import { setLocalizedField } from '@/features/editor/lib/localizedField'
import { requestImageReplace } from '@/features/editor/lib/designImageReplace'
import { QBtn } from './quickToolbarParts'

interface Props {
  element: DesignImage
  onUpdate: (patch: Partial<DesignElement>) => void
}

/**
 * «Заменить» и «Удалить» в быстром тулбаре картинки: удалить — снять только картинку
 * (элемент остаётся пустой зоной загрузки), а не удалить элемент целиком, как корзина
 * сбоку. Слот — язык правки, как у панели справа.
 */
export const ImageActions = ({ element, onUpdate }: Props) => {
  const m = useMessages(messages)
  const contentLang = useContentLang()
  return (
    <span className="flex items-center gap-0.5">
      <QBtn title={m.replaceImage} onClick={() => requestImageReplace(element.id)}>
        <RefreshCw className="size-4" />
        <span className="ml-1.5">{m.replace}</span>
      </QBtn>
      <QBtn
        title={m.removeImage}
        onClick={() =>
          onUpdate(setLocalizedField('imageUrl', contentLang, '') as Partial<DesignElement>)
        }
      >
        <Trash2 className="size-4" />
        <span className="ml-1.5">{m.remove}</span>
      </QBtn>
    </span>
  )
}
